import { OnInit, Component, ViewEncapsulation, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { ValidatorService } from 'app/shared/services/validator.service';
import { IResult } from 'app/shared/models/result.model';
import { Subject, Observable } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppConfig } from 'app/app.config';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { CustomerService } from 'app/views/appviews/quote/customer.service';
import { IDtoProject } from 'app/shared/models/customer/dto-project.model';
import { OrganizationService } from 'app/views/appviews/organization/organization.service';
import { IDtoRiskPremium } from 'app/shared/models/organization/dto-risk-premium.model';
import { IDtoModuleLog } from 'app/shared/models/security/dto-module-log.model';
import { IdentityService } from 'app/views/appviews/security/identity.service';
import { PositionService } from 'app/views/appviews/quote/position.service';

@Component({
    selector: 'app-modal-project',
    styleUrls: ['./modal-project.style.scss'],
    templateUrl: './modal-project.template.html',
    encapsulation: ViewEncapsulation.None
})

export class ModalProjectComponet implements OnInit {
    /**Validadores */
    private validator = ValidatorService;
    private fsaFlags = [false];
    private errorMessages: any;
    /**Formularios */
    private formProject: FormGroup;
    /**Variable de trasporte de datos */
    private result: IResult;
    /**Retorno a pantalla padre */
    public onClose: Subject<any>;
    /**Variables */
    private customerId: number;
    private staffType: string;
    private project: IDtoProject;
    private action: string;
    /**Catalogos */
    private catalogCategories: Observable<IDtoCatalog[]>;
    private catalogAccountExecutives: Observable<IDtoCatalog[]>;
    private catalogApprovers: Observable<IDtoCatalog[]>;
    private catalogCompanies: Observable<IDtoCatalog[]>;
    private riskPremium = {} as IDtoRiskPremium;
    constructor(private bsModalRef: BsModalRef
        , private formBuilder: FormBuilder
        , private customerService: CustomerService
        , private configGeneral: AppConfig
        , private organizationService: OrganizationService
        , private identityService: IdentityService
        , private positionService: PositionService) {
        this.initializeFormProject();
    }
    ngOnInit(): void {
        this.catalogCategories = this.customerService.getCatalogCategories();
        this.catalogAccountExecutives = this.customerService.getCatalogAccountExecutives();
        this.catalogApprovers = this.customerService.getCatalogApprovers(this.customerId);
        this.catalogCompanies = this.organizationService.getCatalogCompanies();
        this.onClose = new Subject();
        if (this.action === 'edit') {
            this.formProject.patchValue(this.project);
        }
        if(this.staffType == 'Oficina') {
            this.formProject.get('payCompanyId').setValidators([Validators.required]);
            this.formProject.get('riskPremiumValue').setValidators([Validators.required]);
            this.formProject.get('payCompanyId').updateValueAndValidity();
            this.formProject.get('riskPremiumValue').updateValueAndValidity();
        }
    }
    private initializeFormProject() {
        this.formProject = this.formBuilder.group({
            codeNom: [null, []],
            name: [null, [Validators.required, Validators.maxLength(255)]],
            description:[null, [Validators.maxLength(255)]],
            categoryId: [null, [Validators.required]],
            accountExecutiveId: [null, [Validators.required]],
            approversId: [null, [Validators.required]],
            payCompanyId: [null],
            riskPremiumValue: [null],
            isActive: [null, [Validators.required]],
            showPayroll: [null, [Validators.required]],
        });
    }
    private submit(): void {
        if (this.formProject.valid) {
            if (this.action === 'add') {
                this.save();
            } else {
                this.update();
            }
        } else {
            this.configGeneral.newToast('Validación', 'Capture toda la información requerida para poder continuar', 'warning');
            this.configGeneral.touchedControls(this.formProject);
        }
    }
    private save(): void {
        const dto = this.formProject.value as IDtoProject;
        dto.customerId = this.customerId;
        this.customerService.addProject(dto)
            .subscribe(
                (x) => {
                    if (this.configGeneral.notificationSuccessError(x)) {
                        let p = x.data as IDtoProject;
                        this.addModuleLog(p.id, 'new');
                        this.onClose.next(true);
                        this.bsModalRef.hide();
                    }
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    private update(): void {
        const dto = this.formProject.value as IDtoProject;
        dto.id = this.project.id;
        dto.customerId = this.project.customerId;
        this.customerService.updateProject(dto)
            .subscribe(
                (x) => {
                    if (this.configGeneral.notificationSuccessError(x)) {
                        if (this.project.riskPremiumValue != +dto.riskPremiumValue) {
                            this.updatePositionMasiveByProject(dto.riskPremiumValue);
                        }
                        this.addModuleLog(dto.id, 'update');
                        this.onClose.next(true);
                        this.bsModalRef.hide();
                    }
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    private getRiskPremiumByCompanyId(dto: IDtoCatalog): void {
        if (dto == null) {
            this.formProject.get('riskPremiumValue').setValue(null);
            return;
        }
        this.organizationService.getRiskPremiumByCompanyId(dto.id).subscribe(res => {
            if (res.data == null) {
                this.configGeneral.newToast('Validación', 'No existe una prima de riesgo activa para esta compañia', 'warning');
                this.formProject.get('riskPremiumValue').setValue(null);
            } else {
                this.riskPremium = res.data as IDtoRiskPremium;
                this.formProject.get('riskPremiumValue').setValue(this.riskPremium.value);
            }
        })
    }
    private onCancel(): void {
        this.bsModalRef.hide();
    }
    private updatePositionMasiveByProject(riskPremiumValue: number): void {
        const dto = {} as IDtoCatalog;
        dto.id = this.project.id;
        dto.name = `${riskPremiumValue}`;
        this.positionService.updatePositionMasiveByProject(dto)
            .subscribe(
                (x) => {
                    if (x.isCorrect == false) {
                        this.configGeneral.newToast('Error', 'La actualización de puestos no pudo ser completada', 'error');
                    }
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    private addModuleLog(id: number, action: string): void {
        let dto = {} as IDtoModuleLog;
        dto.table = 'ProjectCustomers';
        dto.module = 'projects';
        dto.action = action;
        dto.registryAffectedId = id;
        this.identityService.addModuleLog(dto).subscribe(
            (x) => { });
    }
}
